import './apiRuntime';
import './staleChunkReload';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { AuthProvider } from 'react-oidc-context';
import {
  MICROSOFT_CALLBACK_PATH,
  safeReturnPath,
} from '@consolidocs-ui/components';
import type { User } from 'oidc-client-ts';
import { ErrorBoundary } from './Components/ErrorBoundary';
import { cognitoAuthConfig } from '_utils/authConfig';
import './i18n';
import '@fontsource/roboto';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './index.css';

// Back from Cognito's hosted UI (Google): land on the page the user asked for
// before being sent to sign in, which the sign-in page put in the state.
const onSigninCallback = (user: User | void): void => {
  const state = user?.state as { returnTo?: unknown } | undefined;
  window.location.href = safeReturnPath(state?.returnTo);
};

createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    <AuthProvider
      {...cognitoAuthConfig}
      onSigninCallback={onSigninCallback}
      // Microsoft returns there with its own ?code=&state=, which the sign-in
      // screen finishes; the Cognito provider must not try to redeem it.
      skipSigninCallback={window.location.pathname === MICROSOFT_CALLBACK_PATH}
    >
      <StrictMode>
        <App />
      </StrictMode>
    </AuthProvider>
  </ErrorBoundary>
);
